import { styled as e } from "styled-components";
const r = e.div`
  margin-bottom: 8px;
`;
e.div`
  display: block;
  box-sizing: border-box;
  overflow: hidden;
  max-height: 125px;

  @media screen {
    max-height: 250px;
  }
`;
const i = e.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  word-break: break-word;
`;
export {
  i as ContentWrapper,
  r as ParentCommentWrapper
};
